module.exports = __webpack_public_path__ + "static/media/attachment-selected.43fb31c4.png";